import React from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import Image from "../../../../components/image";
import { asset } from "../../../../helpers/dom.helper";
import "./style.scss";
import { Link } from "react-router-dom";
import { toRoute } from "../../../../i18n";
import { Media, MediaContextProvider } from "../../../../media";
import { SHOPPING_AIDS_ITEM } from "./shoppingAidsJson";


function ShoppingAids(props) {


  return (
    <>
      <Helmet>
        <title>Luxury Custom Made Mirrors for Jewelry | Lussopack</title>
        <meta name="description" content="Add a touch of luxury with custom high-quality jewelry mirrors from Lussopack. Discover our custom-size mirrors designed to reflect the elegance of your jewelry." />
        <meta name="keywords" content="custom made mirror" />
        <link rel="canonical" href="https://lussopack.com/packaging/shopping-aids/" />  
      </Helmet>

      {/* <ScrollToTopOnMount /> */}
      <HeaderTitle
        {...props}
        textHeader={"Shopping Aids"}
      />
      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="shoppingAid">
              <h2>Mirror</h2>
              <div className="shoppingAidsList">
              {
                SHOPPING_AIDS_ITEM.map((shoppingAid, index)=>(
                  <div className={`shoppingAidsItem`} key={index}>
                    <Link to={toRoute(shoppingAid.path)}>
                      <Image
                        src={asset(`${shoppingAid.itemImageDesktop}`)}
                        alt={`${shoppingAid.item}`}
                        className="img-fluid zoom"
                        width="345"
                        height="345"
                      />
                    </Link>
                    <Link to={toRoute(shoppingAid.path)}>
                      <p>{shoppingAid.item}</p>
                    </Link>
                  </div>
                ))
              }
            </div>
            <p>Mirrors are an <b>essential shopping aid</b> for jewelers, allowing customers to see themselves from all angles while trying on jewelry. Lussopack can help jewelers by providing <b>custom-made mirrors</b> that are the perfect size and shape for their jewelry cases. By partnering with a Lussopack, jewelers can ensure that they have the premium mirrors they need to provide their customers with a <b>positive shopping experience.</b></p>
            <p>If you are a jeweler looking for a way to improve your customer shopping experience, Lussopack's customized mirrors are the perfect solution for you. Contact us today to learn more about our mirror customization options and to get a quote.</p>

            <h3>Benefits of Using Customized Mirrors for Jewellers</h3>
            <p>There are many benefits to using customized mirrors as a shopping aid for jewelers. Here are just a few:</p>
            <ul>
              <li><b>Improved customer experience: </b>Customized mirrors can help jewelers create a more personalized and engaging shopping experience for their customers.</li>
              <li><b>Increased sales: </b>Customized mirrors can help jewelers sell more jewelry by showcasing their products in the best possible light and by making it easy for customers to try on different pieces.</li>
              <li><b>Brand awareness: </b>Customized mirrors can help jewelers increase brand awareness and loyalty by displaying their branding and messaging in a prominent location in their stores.</li>
            </ul>
            <h3>How to Get Started</h3>
            <p>If you are a jeweler who is interested in getting a customized mirror, Lussopack can help. We offer a wide range of customization options, so you can create a mirror that perfectly matches your needs and budget.</p>
            <p>To get started, simply contact us and let us know what you are looking for. We will work with you to design a mirror that meets your specific needs and requirements. We look forward to helping you create a customized mirror that will help you improve your customer shopping experience and increase your sales.</p>

          </div>
        </Media>
        <Media lessThan="md">
          <div id="shoppingAidMobile">
              <h2>Mirror</h2>
              <div className="shoppingAidsList">
              {
                SHOPPING_AIDS_ITEM.map((shoppingAid, index)=>(
                  <div className={`shoppingAidsItem`} key={index}>
                    <Link to={toRoute(shoppingAid.path)}>
                      <Image
                        src={asset(`${shoppingAid.itemImageDesktop}`)}
                        alt={`${shoppingAid.item}`}
                        className="img-fluid"
                        width="345"
                        height="345"
                      />
                      <p>{shoppingAid.item}</p>
                    </Link>
                  </div>
                ))
              }
            </div>
            <p>Mirrors are an <b>essential shopping aid</b> for jewelers, allowing customers to see themselves from all angles while trying on jewelry. Lussopack can help jewelers by providing <b>custom-made mirrors</b> that are the perfect size and shape for their jewelry cases. By partnering with a Lussopack, jewelers can ensure that they have the premium mirrors they need to provide their customers with a <b>positive shopping experience.</b></p>
            <p>If you are a jeweler looking for a way to improve your customer shopping experience, Lussopack's customized mirrors are the perfect solution for you. Contact us today to learn more about our mirror customization options and to get a quote.</p>

            <h3>Benefits of Using Customized Mirrors for Jewellers</h3>
            <p>There are many benefits to using customized mirrors as a shopping aid for jewelers. Here are just a few:</p>
            <ul>
              <li><b>Improved customer experience: </b>Customized mirrors can help jewelers create a more personalized and engaging shopping experience for their customers.</li>
              <li><b>Increased sales: </b>Customized mirrors can help jewelers sell more jewelry by showcasing their products in the best possible light and by making it easy for customers to try on different pieces.</li>
              <li><b>Brand awareness: </b>Customized mirrors can help jewelers increase brand awareness and loyalty by displaying their branding and messaging in a prominent location in their stores.</li>
            </ul>
            <h3>How to Get Started</h3>
            <p>If you are a jeweler who is interested in getting a customized mirror, Lussopack can help. We offer a wide range of customization options, so you can create a mirror that perfectly matches your needs and budget.</p>
            <p>To get started, simply contact us and let us know what you are looking for. We will work with you to design a mirror that meets your specific needs and requirements. We look forward to helping you create a customized mirror that will help you improve your customer shopping experience and increase your sales.</p>

          </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default ShoppingAids;
